import React from "react";
import {
  FaHome,
  FaUser,
  FaChartBar,
  FaLayerGroup,
  FaFileAlt,
  FaImages,
  FaCogs,
  FaQuoteRight,
  FaEnvelope,
} from "react-icons/fa";

const links = [
  { id: "home", label: "Home", Icon: FaHome },
  { id: "stats", label: "Stats", Icon: FaChartBar },
  { id: "about", label: "About", Icon: FaUser },
  { id: "skills", label: "Skills", Icon: FaLayerGroup },
  { id: "resume", label: "Resume", Icon: FaFileAlt },
  { id: "portfolio", label: "Projects", Icon: FaImages },
  { id: "services", label: "Services", Icon: FaCogs },
  { id: "testimonials", label: "Testimonials", Icon: FaQuoteRight },
  { id: "contact", label: "Contact", Icon: FaEnvelope },
];

export default function Sidebar({ activeSection = "home" }) {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <aside
      className="fixed left-4 top-20 md:top-24 z-40 hidden sm:block group"
      aria-label="Section navigation"
    >
      <div className="glass w-14 group-hover:w-48 transition-all duration-300 rounded-2xl p-2 overflow-hidden">
        <nav className="flex flex-col gap-2">
          {links.map(({ id, label, Icon }) => {
            const active = activeSection === id;
            return (
              <button
                key={id}
                onClick={() => go(id)}
                className={`flex items-center gap-3 rounded-xl px-3 py-2 text-sm transition-colors ${
                  active
                    ? "bg-blue-600 text-white"
                    : "text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-white/10"
                }`}
                aria-current={active ? "true" : undefined}
              >
                <Icon
                  className={`text-base ${
                    active ? "text-white" : "text-blue-600 dark:text-blue-400"
                  }`}
                />
                <span className="whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                  {label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
